<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/search.json"></i18n>
<i18n src="@/lang/confirmations.json"></i18n>

<template>
  <el-main v-if="service">
    <el-container class="service-details">
      <el-aside class="service-details__aside">
        <service-details-element :service="service" />
      </el-aside>
      <el-main class="service-details__main">
        <el-row class="service-details-section">
          <service-info-section :service="service" />
        </el-row>
        <el-row class="service-details-section" v-if="service.isScript">
          <scripts-settings-section :service="service" />
        </el-row>
        <el-row class="service-details-section">
          <periods-section :service="service" />
        </el-row>
        <el-row class="service-details-section" v-if="service.details.api_key">
          <apikey-section :service="service" />
        </el-row>
        <el-row class="service-details-section" v-if="service.isWidget">
          <oauth-section :service="service" />
        </el-row>
      </el-main>
    </el-container>
  </el-main>
</template>

<script>
import PeriodsSection from "./elements/periods/periods-section";
import ServiceDetailsElement from "./elements/ServiceDetailsElement";
import ApikeySection from "./elements/apikey/apikey-section";
import ServiceInfoSection from "./elements/service-info/service-info-section";
import ScriptsSettingsSection from "./elements/script-settings/script-settings-section";
import OauthSection from "./elements/oauth/oauth-section";

export default {
  name: "ServicesDetails",
  components: {
    ServiceInfoSection,
    ApikeySection,
    ServiceDetailsElement,
    PeriodsSection,
    ScriptsSettingsSection,
    OauthSection
  },
  props: {
    service: Object,
    id: String, // this is Customer id
    amo_id: String,
    service_id: String
  },
  data: () => ({}),
  methods: {},
  computed: {}
};
</script>

<style scoped lang="stylus">
.service-details
    &__aside
        width 258px !important
        background #f0f0f0
        border 1px solid #d3d7d8
        border-right none
        padding 33px 28px 0

    &__main
        background-color #ffffff
        border 1px solid #d3d7d8
        padding 33px 28px 40px
        width 100%

        & .service-details-section
            &:not(:last-child)
                margin-bottom 50px
</style>
